// extracted by mini-css-extract-plugin
module.exports = {"actionsPopover":"OfficeRequests_actionsPopover__1cYlJ","actionsDropdownContent":"OfficeRequests_actionsDropdownContent__1mAQl"};